import moment from "moment";
import { Contract } from "../../classes";
const ContractModule = {
  namespaced: true,
  state: {
    contracts: [],
    contract: null
  },
  actions: {
    createContract: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const dataNormalization = {
          marketId: rootGetters["markets/getMarketId"],
          customerId: rootGetters["customer/getCustomerObjectId"],
          startDate: moment(payload.startDate).startOf("day"),
          endDate: moment(payload.endDate).endOf("day"),
          type: payload.type,
          billingData: payload.billingData,
          businessName: payload.businessName,
          stallType: payload.stallType,
          creditTerm: payload.creditTerm,
          areas: payload.areaIds?.map(item => ({
            id: item.area.objectId,
            productIds: item.products?.map(r => r.objectId)
          })),
          startMeterData: payload.startMeterData,
          isNotCheckInArea: payload.isNotCheckInArea,
          bookingId: payload.bookingId
        };

        const data = await Contract.createContract(dataNormalization);
        return data;
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    getContracts: async ({ commit }, payload) => {
      try {
        const data = await Contract.getContracts({
          marketId: payload.marketId
        });
        commit("setContracts", data);
      } catch (err) {
        console.error(err)
        throw err;
      }
    },
    renewContract: async ({ commit }, payload) => {
      try {
        const newObj = {
          ...payload,
        };
        const data = await Contract.renewContract(newObj);
        return data
      } catch (err) {
        console.error(err)
        throw err;
      }
    },
    getContract: async ({ commit }, payload) => {
      try {
        const data = await Contract.getContract({ id: payload.id });
        commit("setContract", data);
        return data;
      } catch (err) {
        console.error(err)
        throw err;
      }
    },
    getContractsByCustomer: async ({ commit, dispatch }, payload) => {
      try {
        const data = await Contract.getContractsByCustomer({
          customerId: payload.customerId,
          marketId: payload.marketId
        });
        if(data?.length && payload.isFetchLog) {
          const contractIds = data.map(item => item.objectId);
          const contractLogs = await dispatch('contractLog/getContractLogByContracts', {
            contractIds: contractIds,
            include: ["fromCustomer", "toCustomer", "createdBy", "oldContract", "newContract"]
          }, { root: true });
          data.forEach(item => {
            if (contractLogs && Array.isArray(contractLogs)) {
              const logsByContract = contractLogs.filter(log => log.contract && log.contract.objectId === item.objectId);
              const oldContract = contractLogs.filter(log => log.oldContract && log.oldContract.objectId === item.objectId);
              
              if(!item.contractLog) {
                item.contractLog = logsByContract.length > 0 ? 
                  [...logsByContract].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) : [];
              } else {
                item.contractLog = [...item.contractLog, ...logsByContract].sort((a, b) => 
                  new Date(b.createdAt) - new Date(a.createdAt)
                );
              }
              
              if(!item.oldContract) {
                item.oldContract = oldContract.length > 0 ? 
                  [...oldContract].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) : [];
              } else {
                item.oldContract = [...item.oldContract, ...oldContract].sort((a, b) => 
                  new Date(b.createdAt) - new Date(a.createdAt)
                );
              }
            } else {
              if (!item.contractLog) item.contractLog = [];
              if (!item.oldContract) item.oldContract = [];
            }
          });
        }
        commit("setContracts", data);
        return data;
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    updateContract: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const input = {
          id: payload.raw.objectId,
          startDate: moment(payload.startDate).startOf("day"),
          endDate: moment(payload.endDate).endOf("day"),
          type: payload.type,
          productIds: payload.productIds,
          businessName: payload.businessName,
          billingData: payload.billingData,
          stallType: payload.stallType,
          creditTerm: payload.creditTerm,
          startMeterData: payload.startMeterData
        };
        const data = await Contract.updateContract(input);
        if (!payload.isNotUpdateStore)
          dispatch("getContract", { id: payload.raw.objectId });
        return data;
      } catch (err) {
        console.error(err)
        throw err;
      }
    },
    addContractAreas: async ({ dispatch }, payload) => {
      try {
        const input = {
          id: payload.id,
          area: {
            id: payload.area.area.objectId,
            productIds: payload.area.products.map(r => r.objectId)
          }
        };
        const data = await Contract.addContractArea(input);
        dispatch("getContract", { id: payload.id });
        return data;
      } catch (err) {
        console.error(err);
        return false;
      }
    },
    removeContractArea: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const input = {
          id: payload.id,
          areaId: payload.areaId
        };
        const data = await Contract.removeContractArea(input);
        dispatch("getContract", { id: payload.id });
        return data;
      } catch (err) {
        console.error(err)
        return false;
      }
    },
    getNewContractsBetweenDateByMarket: async (
      { commit },
      { marketId, startDate, endDate }
    ) => {
      try {
        const data = await Contract.getNewContractsBetweenDateByMarket(
          marketId,
          startDate,
          endDate
        );
        commit("setContracts", data);
        return data;
      } catch (error) {
        console.log(error)
        throw error;
      }
    },
    getContractsBetweenDateByMarket: async (
      { commit },
      { marketId, startDate, endDate }
    ) => {
      try {
        const data = await Contract.getContractsBetweenDateByMarket(
          marketId,
          startDate,
          endDate
        );
        return data;
      } catch (error) {
        console.log(error)
        throw error;
      }
    },
    getActiveContractsBetweenDateByMarket: async (
      { commit },
      { marketId, startDate, endDate }
    ) => {
      try {
        const data = await Contract.getActiveContractsBetweenDateByMarket(
          marketId,
          startDate,
          endDate
        );
        return data;
      } catch (error) {
        console.log(error)
        throw error;
      }
    },
    getActiveContractByMarket: async ({ commit }, formData) => {
      try {
        const data = await Contract.getActiveContractByMarket(formData);
        return data;
      } catch (error) {
        console.log(error)
        throw error;
      }
    },
    getContractWillExpiredByMarket: async ({ commit }, formData) => {
      try {
        const data = await Contract.getContractWillExpiredByMarket(formData);
        return data;
      } catch (error) {
        console.log(error)
        throw error;
      }
    }
  },
  getters: {
    getContract: state => state.contract,
    getContracts: state => {
      return state.contracts;
    },
    getContractsActive: state => {
      let contract = state.contracts.find(c => c.renewEffectiveContract)
      if (contract?.renewEffectiveContract) {
        const renewContractIndex = state.contracts.findIndex(c => c.objectId === contract.renewEffectiveContract.objectId)
        if (renewContractIndex !== -1) {
          state.contracts[renewContractIndex].isActive = true
          state.contracts[renewContractIndex].renewForMainContract = {
            contractId: contract.objectId,
            renewEffectiveDateFormat: contract.renewEffectiveDateFormat,
            renewEffectiveDate: contract.renewEffectiveDate,
          }
        }
      }
      return state.contracts
        .filter(c => c.isActive)
        .sort((a, b) => {
          return a.ageExpire - b.ageExpire;
        });
    },
    getContractsNotActive: state => {
      state.contracts.forEach(contract => {
        if (contract.oldContract && contract.oldContract.length > 0) {
          const renewLog = contract.oldContract.find(log => 
            log.type === 'renew' && log.oldContract && log.oldContract.objectId
          );
          if (renewLog) {
            contract.renewAppeal = {
              objectId: renewLog.oldContract.objectId
            };
          }
        }
      });
      return state.contracts
        .filter(c => !c.isActive)
        .sort((a, b) => {
          return new Date(b.endDate.iso) - new Date(a.endDate.iso);
        });
    },
    getRenewInContracts: state => {
      let res
      if (state?.contracts?.length) {
        let contract = state.contracts.find(c => c.renewEffectiveContract)
        if (contract?.renewEffectiveContract) res = state.contracts.find(c => c.objectId == contract.renewEffectiveContract.objectId)
      }
      return res
    },
    getContractId: state => state.contract?.objectId,
    getCustomerId: state => state.contract?.customer?.objectId,
    getAreas: state => state.contract?.areas.sort(function (a, b) {
      if (b.order > a.order) return -1;
      else return 1;
    })
  },
  mutations: {
    setContract: (state, contract) => {
      state.contract = contract;
    },
    setContracts: (state, contracts) => {
      state.contracts = contracts;
    }
  }
};
export default ContractModule;
